<template>
	<div>
		<topTab ref="topTab" :tab-data="tabData" @tab-change="changePages">
			<el-form :inline="true" :model="formInline" class="user-search">
				<el-form-item label="所属门店：">
					<el-select filterable v-model="formInline.storeKeyId" placeholder="请选择门店" clearable size="small" @change="getListData">
						<el-option v-for="item in storeList" :key="item.keyId" :label="item.value" :value="item.keyId"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="订单编号：">
					<el-input clearable v-model="formInline.orderNo" size="small" placeholder="请输入订单编号" @keyup.enter.native="inputChange"></el-input>
				</el-form-item>
				<el-form-item label="是否入库：">
					<el-select v-model="formInline.isInputStore" placeholder="请选择是否入库" size="small" width="120">
						<el-option label="全部" :value="null" />
						<el-option label="已入库" :value="true" />
						<el-option label="未入库" :value="false" />
					</el-select>
				</el-form-item>
				<el-form-item label="是否导出：">
					<el-select v-model="formInline.isExport" placeholder="请选择是否导出" size="small" width="120">
						<el-option label="全部" :value="null" />
						<el-option label="已导出" :value="true" />
						<el-option label="未导出" :value="false" />
					</el-select>
				</el-form-item>
				<el-form-item label="镜片名称">
					<el-input clearable v-model="formInline.lensName" size="small" placeholder="请输入镜片名称" @keyup.enter.native="inputChange"></el-input>
				</el-form-item>
				<el-form-item label="商品信息：">
					<el-cascader
						v-model="formInline.typeKeyId"
						size="small"
						:options="goodsTypeList"
						:props="cascaderProps"
						placeholder="请选择商品信息"
						clearable
						filterable
						@change="handleTypeChange"
					></el-cascader>
				</el-form-item>
				<el-form-item label="球镜">
					<el-select v-model="formInline.paramsKeyId1" placeholder="请选择球镜" clearable size="small" filterable @change="handleParamsChange">
						<el-option v-for="item in qiuJingList" :key="item.keyId" :label="item.paramsValue" :value="item.keyId"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="柱镜">
					<el-select v-model="formInline.paramsKeyId2" placeholder="请选择柱镜" clearable size="small" filterable @change="handleParamsChange">
						<el-option v-for="item in zhuJingList" :key="item.keyId" :label="item.paramsValue" :value="item.keyId"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="需求时间：">
					<el-date-picker
						v-model="dateValue"
						clearable
						size="small"
						type="daterange"
						value-format="yyyy-MM-dd"
						format="yyyy-MM-dd"
						range-separator="至"
						start-placeholder="开始日期"
						end-placeholder="结束日期"
						@change="handleDateChange"
					></el-date-picker>
				</el-form-item>
				<el-form-item label="顾客姓名：">
					<el-input clearable v-model="formInline.customerName" size="small" placeholder="请输入顾客姓名" @keyup.enter.native="inputChange"></el-input>
				</el-form-item>
				<el-form-item label="顾客电话：">
					<el-input clearable v-model="formInline.customerPhone" size="small" placeholder="请输入顾客电话" @keyup.enter.native="inputChange"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button v-if="$checkBtnPermission('/purchaseOrder/index', 'viewPage')" size="small" type="primary" class="el-icon-search" @click="inputChange()">搜索</el-button>
					<el-button v-if="$checkBtnPermission('/purchaseOrder/index', 'reset')" size="small" icon="el-icon-refresh" @click="clearAll">重置</el-button>
					<el-button v-if="$checkBtnPermission('/purchaseOrder/index', 'export')" size="small" type="warning" icon="el-icon-s-promotion" :loading="exportLoading" @click="handleexportData">导出</el-button>
					<el-button v-if="$checkBtnPermission('/purchaseOrder/index', 'editSupply')" size="small" type="primary" icon="el-icon-edit" @click="handleEditSupply">修改供应商</el-button>
					<el-button v-if="$checkBtnPermission('/purchaseOrder/index', 'createInputStore')" size="small" type="primary" icon="el-icon-edit" @click="handleCreateInputStore">创建入库单</el-button>
					<el-button v-if="$checkBtnPermission('/purchaseOrder/index', 'delete')" size="small" type="danger" class="el-icon-delete" @click="handleDeletePurchaseOrder">删除</el-button>
				</el-form-item>
			</el-form>
			<STable :columns="columnsData" :data="listData" :loading="loading" border @get-data="getListData" @selection-change="handleSelectionChange">
				<template #lR>
					<el-table-column align="center" label="左右眼" min-width="120">
						<template #default="scope">
							<span v-if="scope.row.lr === 1">左眼</span>
							<span v-else-if="scope.row.lr === 0">右眼</span>
						</template>
					</el-table-column>
				</template>
				<template #storeOrderNo>
					<el-table-column align="center" label="订单编号" min-width="240">
						<template #default="scope">
							<el-link type="primary" @click="showPurchaseOrderDetail(scope.row.belongStoreOrderKeyId)">
								{{ scope.row.storeOrderNo }}
							</el-link>
						</template>
					</el-table-column>
				</template>
				<template #isInputStore>
					<el-table-column align="center" label="是否入库" min-width="120">
						<template #default="scope">
							<span v-if="scope.row.isInputStore == true" class="one_1">已入库</span>
							<span v-else class="one_2">未入库</span>
						</template>
					</el-table-column>
				</template>
				<template #isExport>
					<el-table-column align="center" label="是否导出" min-width="120">
						<template #default="scope">
							<span v-if="scope.row.isExport == true" class="one_1">已导出</span>
							<span v-else class="one_2">未导出</span>
						</template>
					</el-table-column>
				</template>
			</STable>
			<!-- 分页组件 -->
			<Pagination v-if="pageShow" :child-msg="pageparm" @call-father="callFather"></Pagination>
		</topTab>
		<selectSupply ref="selectSupply" @choose-supply="chooseSupply"></selectSupply>
		<storeOrdeDetail ref="storeOrdeDetail"></storeOrdeDetail>
		<exportBlockDialog :visible.sync="exportBlockVisible" :title="exportBlockTitle" :blocks="exportBlockData" />
	</div>
</template>

<script>
import { GetPurchaseOrderPageList, ExportPurchaseOrder, EditPurchaseOrderSupply, CreateInputStore, DeletePurchaseOrder } from "@/api/receiptApi.js";
import { GetAllGoodsTypeTreePageList, GetGoodsParamsList } from "@/api/baseDataApi.js";
import { GetOrgInfoListByConfig } from "@/api/organizationalApi.js";
import { exportWithLoading } from "@/api/exportFile";
import exportBlockDialog from "@/components/exportBlockDialog.vue";
import selectSupply from "@/views/baseData/supply/selectSupply.vue";
import storeOrdeDetail from "@/views/baseData/storeOrder/order/storeDtl.vue";
export default {
	data() {
		return {
			activeTab: "1",
			tabData: [
				{
					key: "1",
					value: "采购单列表"
				}
			],
			pageShow: true,
			loading: false, // 显示加载
			exportLoading: false, // 导出按钮 loading
			listData: [],
			// 分页参数
			pageparm: {
				pageIndex: 1,
				pageSize: 10,
				total: 0
			},
			goodsTypeList: [],
			qiuJingList: [],
			zhuJingList: [],
			cascaderProps: {
				value: "keyId", // 绑定值的属性名
				label: "name", // 显示文本的属性名
				children: "subList", // 子节点的属性名
				checkStrictly: false, // 可以选择任意一级
				expandTrigger: "click" // 展开方式
			},
			dateValue: [],
			selectionRowKeyIds: [],
			formInline: {
				pageIndex: 1,
				pageSize: 10,
				typeKeyId: "",
				paramsKeyId1: "",
				paramsKeyId2: "",
				startTime: null,
				endTime: null,
				isInputStore: null,
				isExport: null,
				orderNo: "",
				storeKeyId: "",
				lensName: "",
				customerName: "",
				customerPhone: ""
			},
			storeList: [],
			columnsData: [], //显示列
			listColumns: [
				{
					prop: "keyId",
					label: "全选",
					align: "center",
					width: "55",
					isKeep: true,
					selection: true
				},
				{
					prop: "rowNumber",
					label: "序号",
					align: "center",
					width: "80",
					isKeep: true
				},
				{
					prop: "storeName",
					label: "所属门店",
					align: "center",
					isKeep: true,
					width: "100",
					isKeep: true
				},
				{
					prop: "customerInfo.name",
					label: "顾客姓名",
					align: "center",
					isKeep: true,
					width: "100",
					isKeep: true
				},
				{
					prop: "goodsInfo.type",
					label: "商品品牌",
					align: "center",
					isKeep: true,
					width: "140",
					isKeep: true
				},
				{
					prop: "goodsInfo.name",
					label: "商品名称",
					align: "center",
					isKeep: true,
					width: "220",
					isKeep: true
				},
				{
					prop: "goodsInfo.qiuJing",
					label: "球镜",
					align: "center",
					width: "60",
					isKeep: true
				},
				{
					prop: "goodsInfo.zhuJing",
					label: "柱镜",
					align: "center",
					width: "60",
					isKeep: true
				},
				{
				slot: "storeOrderNo",
				label: "订单编号",
				align: "center",
				isKeep: true,
				width: "220"
			},
				{
					prop: "supplyInfo.name",
					label: "所属供应商",
					align: "center",
					isKeep: true,
					width: "140"
				},
				{
					prop: "customerInfo.phone",
					label: "顾客电话",
					align: "center",
					isKeep: true,
					width: "130"
				},
				{
					slot: "lR",
					label: "左右眼",
					align: "center",
					width: "80"
				},
				{
					prop: "zhouWei",
					label: "轴位",
					align: "center",
					width: "80"
				},
				{
					prop: "quantity",
					label: "需求数量",
					align: "center",
					width: "80"
				},
				{
					prop: "orderDate",
					label: "需求时间",
					align: "center",
					width: "160"
				},
				{
					slot: "isInputStore",
					label: "是否入库",
					align: "center",
					width: "80"
				},
				{
					slot: "isExport",
					label: "是否导出",
					align: "center",
					width: "80"
				},
				{
					prop: "exportDate",
					label: "导出时间",
					align: "center",
					width: "160"
				},
				{
					prop: "creator",
					label: "创建人",
					align: "center",
					minWidth: "80"
				},
				{
					prop: "createTime",
					label: "创建时间",
					align: "center",
					minWidth: "160"
				},
				{
					prop: "editor",
					label: "维护人",
					align: "center",
					minWidth: "80"
				},
				{
					prop: "updateTime",
					label: "维护时间",
					align: "center",
				minWidth: "160"
			}
		],
		exportBlockVisible: false,
		exportBlockTitle: "",
		exportBlockData: []
	};
	},
	// 注册组件
	components: {
		selectSupply,
		storeOrdeDetail,
		exportBlockDialog
	},
	created() {
		// 初始列
		this.getCheckBox(this.listColumns.map((item) => item.label));
		this.GetOrgInfoListByConfig();
		this.getListData();
		this.GetAllGoodsTypeTreePageList();
		this.GetGoodsParamsList();
	},
	computed: {},
	methods: {
		// 获取筛选框
		getCheckBox(val) {
			let arr = this.listColumns.filter((v) => !val.includes(v.label));
			this.columnsData = this.listColumns.filter((i) => !arr.includes(i));
		},
		changePages() {},
		handleDateChange(val) {
			if (val) {
				this.formInline.startTime = val[0];
				this.formInline.endTime = val[1];
			} else {
				this.formInline.startTime = null;
				this.formInline.endTime = null;
			}
		},
		// 获取所属门店
		GetOrgInfoListByConfig() {
			const paramer = {
				key: 1
			};
			GetOrgInfoListByConfig(paramer)
				.then((res) => {
					if (res.code == 1) {
						this.storeList = [];
						if (res.code == 1) {
							res.data.forEach((item) => {
								this.storeList.push({
									keyId: item.keyId,
									value: item.name + "【" + item.remark2 + "】"
								});
							});
						} else {
							this.$message.error(res.msg);
						}
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("获取门店信息失败!");
				});
		},
		// 获取列表
		getListData() {
			this.loading = true;
			GetPurchaseOrderPageList(this.formInline)
				.then((res) => {
					if (res.code == 1) {
						this.loading = false;
						this.listData = res.data;
						this.pageparm.total = res.totalNumber;
					} else {
						this.$message({
							type: "info",
							message: res.msg
						});
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("数据加载失败，请稍后再试！");
				});
		},
		// 重置
		clearAll() {
			this.$data.formInline = this.$options.data.call(this).formInline;
			this.search();
		},
		inputChange(val) {
			this.search();
		},
		// 分页插件事件
		callFather(parm) {
			if (parm.currentPage == undefined) {
				this.formInline.pageIndex = 1;
			} else {
				this.formInline.pageIndex = parm.currentPage;
			}
			this.formInline.pageSize = parm.pageSize;
			this.getListData();
		},
		// 搜索事件
		search() {
			this.formInline.pageIndex = 1;
			this.pageShow = false;
			this.$nextTick(() => {
				this.pageShow = true;
			});
			this.getListData();
		},
		// 选择行
		handleSelectionChange(val) {
			this.selectionRowKeyIds = val.map((item) => item.keyId);
		},
		//导出选中的数据
		handleexportData() {
			if (this.selectionRowKeyIds.length == 0) {
				this.$message({
					type: "info",
					message: "请选择要导出的数据"
				});
				return;
			}
			this.$confirm("确定要导出选中的数据吗?", "信息", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			})
				.then(() => {
				exportWithLoading(this, "exportLoading", () => ExportPurchaseOrder({
					keyIds: this.selectionRowKeyIds
				}));
			})
			.catch(() => {});
		},
		// 处理商品类型选择变化
		handleTypeChange(value) {
			if (value && value.length > 0) {
				// 取最后一级的值作为typeKeyId
				this.formInline.typeKeyId = value[value.length - 1];
			} else {
				this.formInline.typeKeyId = "";
			}
			this.search();
		},
		// 获取商品类型数据
		GetAllGoodsTypeTreePageList() {
			GetAllGoodsTypeTreePageList({})
				.then((res) => {
					if (res.code == 1) {
						this.goodsTypeList = res.data;
					} else {
						this.$message({
							type: "info",
							message: res.msg
						});
					}
				})
				.catch((err) => {
					this.$message.error("数据加载失败，请稍后再试！");
				});
		},
		//获取商品参数信息
		GetGoodsParamsList() {
			GetGoodsParamsList({})
				.then((res) => {
					if (res.code == 1) {
						this.qiuJingList = res.data.filter((item) => item.type == 1);
						this.zhuJingList = res.data.filter((item) => item.type == 2);
					} else {
						this.$message({
							type: "error",
							message: res.msg
						});
					}
				})
				.catch((err) => {
					this.$message.error("数据加载失败，请稍后再试！");
				});
		},
		// 处理商品参数选择变化
		handleParamsChange(value) {
			this.search();
		},
		// 处理修改供应商
		handleEditSupply() {
			if (this.selectionRowKeyIds.length == 0) {
				this.$message({
					type: "warning",
					message: "请选择要修改供应商的采购商品信息！"
				});
				return;
			}
			this.$confirm("确定要修改选中采购商品的供应商吗?", "信息", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			})
				.then(() => {
					this.$refs.selectSupply.showSelectCustomerDialog();
				})
				.catch(() => {
					this.loading = false;
				});
		},
		// 处理创建入库单
		handleCreateInputStore() {
			if (this.selectionRowKeyIds.length == 0) {
				this.$message({
					type: "warning",
					message: "请选择要创建入库单的采购商品！"
				});
				return;
			}
			this.$confirm("确定要创建选中采购商品的入库单吗?", "信息", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			})
				.then(() => {
					this.loading = true;
					CreateInputStore({
						keyIds: this.selectionRowKeyIds
					})
						.then((res) => {
							if (res.code == 1) {
								this.$message({
									type: "success",
									message: "创建成功"
								});
								this.search();
							} else {
								this.$message({
									type: "info",
									message: res.msg
								});
							}
						})
						.finally(() => {
							this.loading = false;
						});
				})
				.catch(() => {
					this.loading = false;
				});
		},
		// 删除采购单
		handleDeletePurchaseOrder() {
			if (this.selectionRowKeyIds.length == 0) {
				this.$message({
					type: "warning",
					message: "请选择要删除的采购商品！"
				});
				return;
			}
			this.$confirm("确定要删除选中采购单商品吗?", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			})
				.then(() => {
					this.loading = true;
					DeletePurchaseOrder({
						keyIds: this.selectionRowKeyIds
					})
						.then((res) => {
							if (res.code == 1) {
								this.$message({
									type: "success",
									message: "删除成功"
								});
								this.search();
							} else {
								this.$message({
									type: "info",
									message: res.msg
								});
							}
						})
						.finally(() => {
							this.loading = false;
						});
				})
				.catch(() => {
					this.loading = false;
				});
		},
		chooseSupply(keyId) {
			this.loading = true;
			EditPurchaseOrderSupply({
				keyIds: this.selectionRowKeyIds,
				supplyKeyId: keyId
			})
				.then((res) => {
					if (res.code == 1) {
						this.$message({
							type: "success",
							message: "修改成功"
						});
						this.search();
					} else {
						this.$message({
							type: "info",
							message: res.msg
						});
					}
				})
				.finally(() => {
					this.loading = false;
				});
		},
		//展示订单详情信息
		showPurchaseOrderDetail(keyId) {
			if (!keyId) {
				this.$message({ type: "info", message: "该采购单未关联门店订单！" });
				return;
			}
			var row = {
				keyId: keyId
			};
			this.$refs.storeOrdeDetail.showSeeDetailDialog(row, 1);
		}
	}
};
</script>

<style scoped>
.one_1 {
	padding: 2px 20px;
	background: #e6f7ff;
	border: 1px solid #6acaf3;
	color: #56bbfd;
	border-radius: 2px;
}

.one_2 {
	padding: 2px 20px;
	background: #fcd4ff;
	border: 1px solid #dfbce2;
	color: #ea7cff;
	border-radius: 2px;
}
</style>
